import React from 'react';
import { AlertTriangleIcon, HandIcon, MinusCircleIcon } from 'lucide-react';
import { motion } from 'framer-motion';
interface RuleBlockProps {
  icon: React.ReactNode;
  title: string;
  rateLabel: string;
  rate: string;
  exampleLines: string[];
  total: string;
}
function RuleBlock({
  icon,
  title,
  rateLabel,
  rate,
  exampleLines,
  total
}: RuleBlockProps) {
  return <div className="flex gap-3" data-id="element-296">
      <div className="shrink-0 mt-0.5" data-id="element-297">{icon}</div>
      <div className="flex-1 min-w-0" data-id="element-298">
        <h3 className="text-[11px] font-bold text-red-700 uppercase tracking-wider mb-1" data-id="element-299">
          {title}
        </h3>
        <p className="text-[10px] font-bold text-red-600 uppercase tracking-wider mb-1 leading-tight" data-id="element-300">
          {rateLabel}
        </p>
        <p className="text-xs font-bold text-red-600 mb-2" data-id="element-301">{rate}</p>
        <div className="bg-white/70 rounded-lg p-2.5 text-[11px] border border-red-100" data-id="element-302">
          <span className="font-bold text-[#0A1F5C] uppercase block mb-1 text-[10px] tracking-wider" data-id="element-303">
            Example
          </span>
          {exampleLines.map((line, idx) => <p key={idx} className="text-[#0A1F5C] font-medium leading-snug" data-id="element-304">
              {line}
            </p>)}
          <div className="h-px bg-red-100 my-1.5" data-id="element-305" />
          <p className="text-[#0A1F5C] font-bold" data-id="element-306">Total Deduction = {total}</p>
        </div>
      </div>
    </div>;
}
export function PenaltyRules() {
  return <motion.section initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.4,
    delay: 0.4
  }} className="bg-red-50 rounded-xl shadow-sm border border-red-200 overflow-hidden h-full flex flex-col" data-id="element-307">
      <div className="bg-red-600 text-white px-4 py-2.5 flex items-center gap-2 font-semibold text-sm tracking-wide" data-id="element-308">
        <AlertTriangleIcon className="w-4 h-4" data-id="element-309" />
        PENALTY RULES
      </div>

      {/* Total deductions summary at top */}
      <div className="bg-white border-b border-red-100 px-5 py-4 flex items-center gap-3" data-id="element-310">
        <MinusCircleIcon className="w-7 h-7 text-red-600 shrink-0" data-id="element-311" />
        <div className="flex-1" data-id="element-312">
          <h3 className="text-[10px] font-bold text-[#0A1F5C] uppercase tracking-wider" data-id="element-313">
            Total Deductions (MTD)
          </h3>
          <div className="flex items-baseline gap-1.5" data-id="element-314">
            <span className="text-3xl font-bold text-red-600 tabular-nums tracking-tight" data-id="element-315">
              -250
            </span>
            <span className="text-[10px] font-bold text-gray-500 uppercase tracking-wider" data-id="element-316">
              Points
            </span>
          </div>
        </div>
      </div>

      <div className="p-5 space-y-5 flex-1" data-id="element-317">
        <RuleBlock icon={<AlertTriangleIcon className="w-6 h-6 text-red-600" data-id="element-319" />} title="Files Not Moving Penalty" rateLabel="1 day grace period" rate="After 1 day: -50 pts / day / file" exampleLines={['2 Files not moved for 3 days:', '2 × 2 × -50 = -200 Points']} total="-200 Points" data-id="element-318" />

        <div className="border-t border-red-100" data-id="element-320" />

        <RuleBlock icon={<HandIcon className="w-6 h-6 text-red-600" data-id="element-322" />} title="File Not Touched Penalty" rateLabel="No grace period" rate="If not touched 1+ day: -50 pts / day / file" exampleLines={['3 Files not touched for 2 days:', '3 × 2 × -50 = -300 Points']} total="-300 Points" data-id="element-321" />
      </div>

      <div className="bg-white border-t border-red-100 px-5 py-3 text-[10px] text-gray-500 font-medium" data-id="element-323">
        Currently penalized:{' '}
        <span className="text-red-600 font-bold" data-id="element-324">2 at-risk</span> +{' '}
        <span className="text-red-600 font-bold" data-id="element-325">3 not touched</span> files
      </div>
    </motion.section>;
}